module.exports = __webpack_public_path__ + "static/media/man-laughing.c60dc1c2.jpg";